export default "__VITE_ASSET__Cy5nA7nr__"